loadjs.ready(['jquery', 'core'], function() {
    var $form = $('#cart-add-form');
    var $formSubmit = $form.find('button[type="submit"]');
    var $productInfo = $('#product-info');
    var $panel = $productInfo.find('.product-variant-options');
    var currentSelection = {};
    var selectedVariant;
    var $optionModals = $('.product-option-modal');
    var $optionRows = $panel.find('.product-variant-option-row');
    var $productPricing = $('.product-pricing');
    var $personalizationModal;
    var updateSelection = function($el, option, value, cascade) {
        var $currentRow;
        var $nextRow;
        var currentIndex;
        var $nextModals;
        var selectedOptions;
        var availableVariants = [];

        if ($el) {
            currentIndex = parseInt($el.data('row'));
            $currentRow = $optionRows.eq(currentIndex);
            $nextRow = $currentRow.next();

            $currentRow
                .addClass('is-filled')
                .find('.item-title')
                .attr('data-action', 'Modifică ' + option.charAt(0).toLowerCase() + option.slice(1))
                .html(value.charAt(0).toUpperCase() + value.slice(1));
            $optionRows
                .filter(index => index > currentIndex)
                .each(function() {
                    var $el = $(this);
                    $el
                        .removeClass('is-filled')
                        .find('.item-title').attr('data-action', 'Alege o opțiune').html($el.data('option'));
                })


            if (option) {
                currentSelection[option] = value.toString();
                options.forEach(function(o, k) {
                    if (k > currentIndex) {
                        delete currentSelection[o.name];
                    }
                });
            }

            $nextModals = $optionModals.filter(index => index > currentIndex);
        } else {
            currentIndex = -1;
            $optionRows.addClass('is-disabled');
            $nextRow = $optionRows.eq(0);
            $nextModals = $optionModals.eq(0);
        }
        $nextModals
            .find('input').prop('disabled', true).prop('checked', false)
            .closest('.list-item').addClass('is-disabled');

        selectedOptions = Object.keys(currentSelection);

        if ($el) {
            if (selectedOptions.length > 0) {
                availableVariants = variants.filter(function(v) {
                    var matches = 0;
                    v.options.forEach(function (o) {
                        if (typeof currentSelection[o.name] !== 'undefined' && currentSelection[o.name] === o.value.toString()) {
                            matches++;
                        }
                    });

                    return matches === selectedOptions.length;
                });
            }
        } else {
            availableVariants = variants.filter(function(v) {
                return v.in_stock;
            });
        }

        //check if we have a complete selection
        if (selectedOptions.length === options.length) {
            var variant = availableVariants.pop();

            if (typeof variant === 'undefined') {
                variant = null;
            }

            $productInfo.trigger('productVariantChange', [variant, []]);
        } else {
            if ($nextRow.length) {
                var nextOption = options[$nextRow.data('row')];

                if (nextOption.name) {
                    var availableOptions = [];
                    availableVariants.forEach(function(v) {
                        if (v.in_stock) {
                            v.options.forEach(function(o) {
                                if (
                                    nextOption.name === o.name &&
                                    nextOption.values.indexOf(o.value) > -1 &&
                                    availableOptions.indexOf(o.value) === -1
                                ) {
                                    availableOptions.push(o.value);
                                }
                            })
                        }
                    });

                    nextOption.values.forEach(function(o) {
                        if (availableOptions.indexOf(o) > -1) {
                            $optionModals.eq(currentIndex + 1).find('input').filter(function() {
                                return this.value === o;
                            }).prop('disabled', false).closest('.list-item').removeClass('is-disabled');
                        }
                    })
                    if (availableOptions.length) {
                        $nextRow.removeClass('is-disabled');
                    }
                }
            }

            if ($el) {
                var opts = options.map(o => o.name);
                selectedOptions.forEach((o) => {
                    opts.splice(opts.indexOf(o), 1);
                })
                // selection incomplete
                $productInfo.trigger('productVariantChange', [null, opts]);
                if (cascade) {
                    var $e = $optionModals.eq(currentIndex + 1).find('input:not(:disabled)').eq(0);
                    if ($e.length) {
                        $e.prop('checked', true).trigger('change');
                    }
                }
            }

            if (selectedOptions.length >= options.length - 1) {
                $optionModals.eq(options.length - 1).find('input:not(:disabled)').each(function() {
                    var $el = $(this);
                    var opt = $el.data('option');
                    var val = this.value;
                    var v = availableVariants.find(function(v) {
                        var matches = 0;
                        v.options.forEach(function (o) {
                            if (o.name === opt && o.value.toString() === val) {
                                matches++;
                            }
                        });

                        return matches === 1;
                    });

                    if (v) {
                        $el.closest('.list-item').find('.item-title').attr('data-action', v.on_sale ? v.sale_price : v.price);
                    } else {
                        $el.closest('.list-item').find('.item-title').attr('data-action', '');
                    }
                })
            }
        }
    }

    $body
        .on('change', '.product-option-modal', function(e) {
            let $modal = $(this);
            let $input = $modal.find('input:checked');
            updateSelection($input, $input.data('option'), $input.val())

            if ($form.data('success')) {
                $productInfo.find('#cart-add-success').attr('hidden', 'hidden');
                $form.data('success', 0).show()
            }

            if ($modal.is('.in')) {
                $modal.modal('hide');
            }

            if ($optionRows.filter('.is-filled').length < $optionRows.length) {
                setTimeout(function () {
                    $optionRows.filter(':not(.is-filled)').first().click();
                }, 400);
            }
        })

    $form
        .on('success', function(e, response) {
            var ev = getEventId();
            var fbData = {
                content_name: product.title,
                content_category: product.category,
                content_ids: [product.id.toString()],
                content_type: 'product',
                value: selectedVariant ? selectedVariant.price_number : product.price,
                currency: product.currency
            };
            if (response.metadata) {
                updateCartButton(response.metadata);
            }

            dilytics('product', 'addToCart', [product.id], {eventId: ev, fbd: fbData});
            gtag('event', 'add_to_cart', {
                "items": [
                    {
                        "id": product.id.toString(),
                        "name": product.title,
                        "list_name": "Product page",
                        "brand": product.brand,
                        "category": product.category,
                        "variant": selectedVariant ? selectedVariant.options.map(function(o) { return o.value }).join('/') : "",
                        "quantity": 1,
                        "price": selectedVariant ? selectedVariant.price_number.toString() : product.price.toString()
                    }
                ]
            });

            if (product.related) {
                gtag('event', 'related_add_to_cart', {
                    'event_label': product.id,
                    'event_category': 'related_item',
                    'non_interaction': true
                });
            }

            fbq('track', 'AddToCart', fbData, {eventID: ev});
            ttq.track('AddToCart', {
                content_id: product.id.toString(),
                content_type: fbData.content_type,
                value: fbData.value,
                currency: fbData.currency,
                quantity: 1
            });
            conversionAPI(usedPixels, ev, 'AddToCart', fbData);

            $form.data('success', 1).hide();
            $productInfo.find('#cart-add-success').removeAttr('hidden');
            $body.trigger('cart:product:add', {});
        })
        .on('error', function(e, error) {
            if (error && error.quantity) {
                showError(Array.isArray(error.quantity) ? error.quantity.join('<br/>') : error.quantity);
            }
        })
    $productInfo
        .on('productVariantChange', function(e, variant, unselectedOptions) {
            var $input = $form.find('input[name="variantId"]');
            var $banner = $productInfo.find('#cart-add-warning');
            selectedVariant = variant;
            if (variant !== null) {
                if (variant.on_sale) {
                    $productPricing.html(variant.sale_price + ' <span>' + variant.price +  '</span>');
                } else {
                    $productPricing.html(variant.price);
                }
                $input.val(variant.id)
                $banner.attr('hidden', 'hidden');
                $formSubmit.prop('disabled', false);
                if (product.personalize && !product.personalizeOptional) {
                    setTimeout(function () {
                        $personalizationModal.modal('show');
                    }, 300);
                }
            } else {
                $input.val('')
            }
            $banner.find('.options').html(
                unselectedOptions.map(o => `<strong class="option">${o}</strong>`).join('')
            )
        });
    $panel.on('click', '.product-variant-option-row.is-disabled', function() {
        $panel.find('.product-variant-option-row:not(.is-disabled):not(.is-filled)').first().click();
        return false;
    })

    if (product.personalize) {
        $personalizationModal = $('#product-personalization-modal');
        $personalizationModal
            .on('click', 'button', function() {
                var $textarea = $personalizationModal.find('#personalization-instructions');
                var message = $textarea.val().trim();
                if (!product.personalizeOptional && !message.length) {
                    $textarea.focus();
                    return false;
                }
                $panel.find('.product-personalization-option')
                    .toggleClass('is-filled', message.length)
                    .find('.item-title').attr('data-action', 'Modifică informații');
                $form.find('textarea[name="personalizationMessage"]').val(message);
                $personalizationModal.modal('hide');
                return false;
            })
    }

    if ((options && options.length) || (product.personalize && !product.personalizeOptional)) {
        $formSubmit.on('click', function (e) {
            if ((options && options.length)) {
                if (!selectedVariant) {
                    var $unfilledOptions = $productInfo.find('.list-item:not(.is-filled)');
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    $productInfo.find('#cart-add-warning').removeAttr('hidden');
                    $productInfo.find('.list').addClass('needs-filling')
                    $unfilledOptions.removeClass('shake');
                    setTimeout(function () {
                        $unfilledOptions.addClass('shake')
                    }, 100)
                    return false;
                }
            }
            if (product.personalize && !product.personalizeOptional && !$form.find('textarea[name="personalizationMessage"]').val().length) {
                $personalizationModal.modal('show');
            }
        })
    }
    if (options && options.length) {
        updateSelection();
        $formSubmit.prop('disabled', !product.purchasable)
    }
});
var eventId = getEventId();
var fbData = {
    content_name: product.title,
    content_category: product.category,
    content_ids: [product.id.toString()],
    content_type: 'product',
    value: product.price,
    currency: product.currency
};
dilytics('product', 'view', [product.id], {eventId, fbd: fbData});
gtag('event', 'view_item', {
    "items": [{
        id: product.id.toString(),
        name: product.title,
        list_name: "Product page",
        brand: product.brand,
        category: product.category,
        price: product.price.toString(),
        dimension2: product.purchasable ? 'Yes' : 'No',
        dimension3: product.purchasable ? 'Yes' : 'No',
        metric1: product.shippingCost,
        metric2: product.shippingDays,
        metric3: product.availableStock
    }]
});
fbq('track', 'ViewContent', fbData, {eventID: eventId})
ttq.track('ViewContent', {
    content_id: product.id.toString(),
    content_type: fbData.content_type,
    value: product.price,
    currency: product.currency,
    quantity: 1
});
if (usedPixels.length) {
    conversionAPI(usedPixels, eventId, 'ViewContent', fbData);
}
